import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { retourenRoutes } from '@softapps/mde/retouren';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { warenuebernahmeRoutes } from '@softapps/wws/warenuebernahme';
import { eslLinkRoutes } from '@softapps/handel/esl-link';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  // MDE
  ...artikelvorratRoutes,
  ...artikelInfoRoutes,
  ...bestellerfassungRoutes,
  ...bestellvorschlagRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...materiallieferscheinScanRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...warenuebernahmeRoutes,
  ...eslLinkRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];
